export enum SkeletonType {
  Default = 'default',
  Button = 'button',
  Avatar = 'avatar',
  Input = 'input',
  Image = 'image',
}
